export const layersConfig = [
  { id: 90, visible: false },
  { id: 5, visible: true },
  { id: 4, visible: true },
  { id: 3, visible: true, legendEnabled: false },
  // H2S IndicatorBoonLister max zoom
  {
    id: 212 ,
    visible: false,
  },
  // H2S IndicatorBoonLister min zoom
  {
    id: 112,
    visible: false,
  },
  // H2S IndicatorSejourCana max zoom
  {
    id: 213,
    visible: false,
  },
  // H2S IndicatorSejourCana min zoom
  {
    id: 113,
    visible: false,
  },
  // H2S IndicatorSejourPR max zoom
  {
    id: 214,
    visible: false,
  },
  // H2S IndicatorSejourPR min zoom
  {
    id: 114,
    visible: false,
  },
  // H2S IndicatorAutocurage max zoom
  {
    id: 215,
    visible: false,
  },
  // H2S IndicatorAutocurage min zoom
  {
    id: 115,
    visible: false,
  },
  // H2S IndicatorTerrain max zoom
  {
    id: 216,
    visible: false,
  },
  // H2S IndicatorTerrain min zoom
  {
    id: 116,
    visible: false,
  },
  {
    id: 203,
    visible: false,
  },
  {
    id: 103,
    visible: false,
  },
  // MDI_PR service max zoom
  {
    id: 202,
    visible: false,
  },
  //MDI_TP service max zoom
  {
    id: 206,
    visible: false,
  },
  // MDI_PR service min zoom
  {
    id: 102,
    visible: false,
  },
  //MDI_TP service min zoom
  {
    id: 106,
    visible: false,
  },
  // MDI_DO service max zoom
  {
    id: 201,
    visible: false,
  },
  //MDI_MR service max zoom
  {
    id: 205,
    visible: false,
  },
  // MDI_DO service min zoom
  {
    id: 101,
    visible: false,
  },
  //MDI_MR service min zoom
  {
    id: 105,
    visible: false,
  },
  // ECP service min zoom
  {
    id: 107,
    visible: false,
  },
  //ECP service max zoom
  {
    id: 207,
    visible: false,
  },
  //INDUS etablissements
  {
    id: 80,
    visible: false,
  },
  //HYDRO Intervention ponctuel
  {
    id: 301,
    visible: false,
  },
  //HYDRO Intervention linéaire
  {
    id: 302,
    visible: false,
  },
  //HYDRO points noirs
  {
    id: 306,
    visible: false,
  },
  //MILIEU sensibility
  {
    id: 108,
    visible: false,
  },
  {
    id: 208,
    visible: false,
  },
  //MILIEU dilution
  {
    id: 109,
    visible: false,
  },
  {
    id: 209,
    visible: false,
  },
  //PLUIE
  {
    id: 111,
    visible: false,
  },
  {
    id: 211,
    visible: false,
  },
  // PLUIE : pluvio
  {
    id: 110,
    visible: false,
  },
  {
    id: 210,
    visible: false,
  },
  // PRMR/ECP : piézomètres
  {
    id: 117,
    visible: false,
  },
  {
    id: 217,
    visible: false,
  },
];
